import { atom } from "jotai"

export const INIT_ROLE = {
    roleId: null,
    roleName: "",
    status: "", 
    
}

export const roleAtom  = atom(INIT_ROLE)
